// extracted by mini-css-extract-plugin
export default {"container":"ProgramActivities_container__xob87","inputs":"ProgramActivities_inputs__uTCY3","list":"ProgramActivities_list__v+Jvy"};